<template>
  <div>
    <div class="top">
      <div class="top-img">
        <div class="sign">
          <img
            @click="examHandle"
            src="./../assets/2024/exam-button.png"
            alt="去答题"
          />
        </div>
      </div>
    </div>
    <div class="bottom">
      <div>
        <a
          href="https://mp.weixin.qq.com/s/od67jniOA1ZWysLs-aOG8Q"
          ref="noreferrer noopener"
        >
          <div>
            <img src="./../assets/2024/icon-warn.png" width="35" height="35" />
            <span>警惕这些邪教</span>
          </div>
          <img src="./../assets/2024/right-arrow.png" width="20" height="20" />
        </a>
      </div>
      <div>
        <a
          href="https://www.chinafxj.cn/n184/index.html"
          ref="noreferrer noopener"
        >
          <div>
            <img src="./../assets/2024/icon-movie.png" width="35" height="35" />
            <span>影音资料库</span>
          </div>
          <img src="./../assets/2024/right-arrow.png" width="20" height="20" />
        </a>
      </div>
      <div>
        <a
          href="https://www.chinafxj.cn/n250/n2500/n2579/index.html"
          ref="noreferrer noopener"
        >
          <div>
            <img src="./../assets/2024/icon-file.png" width="35" height="35" />
            <span>反邪教资料库</span>
          </div>
          <img src="./../assets/2024/right-arrow.png" width="20" height="20" />
        </a>
      </div>
      <div>
        <a
          @click="showRank"
          href="javascript:void(0)"
          ref="noreferrer noopener"
        >
          <div>
            <img src="./../assets/2024/rank.png" width="35" height="35" />
            <span>各地答题人数统计</span>
          </div>
          <img src="./../assets/2024/right-arrow.png" width="20" height="20" />
        </a>
      </div>
      <!-- <div>
        <a @click="showRank">各地签名量统计（2023年）</a>
      </div> -->
    </div>
    <SelectAddress
      :show="showSeleceAddressDialog"
      @close="closeAddressDialog"
      @change="changeAddress"
    ></SelectAddress>
    <NameEnter
      :show="showNameDialog"
      @close="closeNameEnter"
      @change="changeName"
    ></NameEnter>
    <ExamRank :show="showRankDialog" @close="closeRank"></ExamRank>
    <NoOpenId
      :type="2"
      :show="showNoOpenIdTipDialog"
      @close="closeNoOpenIdTip"
    ></NoOpenId>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import HelloWorld from '@/components/HelloWorld.vue'
import SelectAddress from "@/components/SelectAddress.vue";
import NameEnter from "@/components/NameEnter.vue";
import ExamRank from "@/components/ExamRank.vue";
import NoOpenId from "@/components/NoOpenId.vue";
// import api from "@/api/sign";
import userApi from "@/api/user";
import config from "@/config";
import wechatApi from "@/api/wechat";

export default {
  name: "Home",
  components: {
    SelectAddress,
    NameEnter,
    ExamRank,
    NoOpenId,
  },
  // components: {
  //   HelloWorld
  // }
  data() {
    return {
      showSeleceAddressDialog: false,
      showNameDialog: false,
      showRankDialog: false,
      signParams: {
        encrypt: "", //微信公众号用户唯一标识
        openId: "",
        name: "", //姓名
        province: "", //省份
        provinceCode: "", //省份编码
        city: "", //城市
        cityCode: "", //城市编码
        county: "", //县区
        countyCode: "", //县区编码
        towns: "", //乡镇/街道
        townsCode: "", //乡镇/街道编码
        //key:""//签名key
      },
      isSignIn: false,
      signNumber: null,
      isSubscribed: false,
      loading: null,
      code: "",
      showNoOpenIdTipDialog: false,
      errorStatus: undefined,
      errorText: '23:00 - 06:00',
    };
  },
  mounted() {
    // const obj = new WxLogin({
    //   "self_redirect": true,
    //   id: "login_container",
    //   appid: "",
    //   scope: "",
    //   "redirect_uri": "",
    //   state: "",
    //   style: "",
    //   href: ""
    // });
    // console.log(obj);
    // this.signParams.key=this.getUrlCode().key;
    // if(this.signParams.key!=null&&this.signParams.key!=""&&this.signParams.key!="undefined")
    // {
    //   window.sessionStorage.setItem('key', this.key);
    //   //this.getCode();
    // }
    // if (window.sessionStorage.getItem("token") === null) {
    //   this.getCode();
    // }
    if (window.sessionStorage.getItem("token") === null) {
      this.getCode();
    } else {
      const isSubscribed = window.sessionStorage.getItem("isSubscribed"); // 关注
      const isSignIn = window.sessionStorage.getItem("isSignIn"); // 签名
      // window.sessionStorage.setItem("signNumber", res.result.num);
      if (isSignIn === '1') {
        this.isSignIn = true;
      }
      if (isSubscribed === '1') {
        this.isSubscribed = true;
      }
      wechatApi.wechatReady();
      wechatApi.config();
    }
  },
  methods: {
    // issubscirbe() {
    //   //判断是否关注
    //   if (
    //     this.signParams.openId === "" ||
    //     this.signParams.openId === undefined ||
    //     this.signParams.openId === null
    //   ) {
    //     this.signParams.isSubscribed = window.sessionStorage.getItem("isSubscribed");
    //   }
    //   userApi
    //     .issubscribe({
    //       openId: this.signParams.openId,
    //     })
    //     .then((res) => {
    //       if (res.devMessage === "false") {
    //         this.showNoOpenIdTip();
    //       }
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    // },
    getCode() {
      // 非静默授权，第一次有弹框
      this.code = "";
      const local = window.location.href; // 获取页面url
      const appid = config.appId;
      this.code = this.getUrlCode().code; // 截取code

      if (this.code == null || this.code === "") {
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
          local
          // )}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
        )}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      } else {
        // 你自己的业务逻辑

        // const encrypt = window.sessionStorage.getItem("encrypt");
        // const openId = window.sessionStorage.getItem("openId");
        // const signNumber = window.sessionStorage.getItem("signNumber");
        this.getUserInfo();
        wechatApi.wechatReady();
        // if (
        //   window.sessionStorage.getItem("token") === null
        // ) {
        //   this.getUserInfo();
        // } else {
        //   // this.signParams.encrypt = encrypt;
        //   // this.signParams.openId = openId;
        //   // this.signNumber = signNumber;
        //   // this.isSignIn = isSignIn === "1";
        //   wechatApi.wechatReady();

        //   // this.issubscirbe(); //判断是否关注
        // }
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      const url = location.search;
      const theRequest = new Object();
      if (url.indexOf("?") != -1) {
        const str = url.substr(1);
        const strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    // 获取用户信息
    getUserInfo() {
      this.loading = this.$toast.loading('加载中...',{
        coverColor: "rgba(0,0,0,0.5)",
      })
      userApi
        .getUserInfo({
          code: this.code,
        })
        .then((res) => {
          console.log("getUserInfo=>", res);
          wechatApi.config();
          // this.signParams.encrypt = res.result.encrypt;
          // this.signParams.openId = res.result.openId;
          // this.signNumber = res.result.num;
          // window.sessionStorage.setItem("encrypt", res.isSignIn + 0);
          window.sessionStorage.setItem("token", res.token);
          window.sessionStorage.setItem("currentYear", res.year);
          window.sessionStorage.setItem("isSubscribed", res.isSubscribed + 0); // 关注
          // window.sessionStorage.setItem("signNumber", res.result.num);
          if (res.isSignIn) {
            this.isSignIn = true;
          }
          if (res.isSubscribed) {
            this.isSubscribed = true;
          }
          window.sessionStorage.setItem("isSignIn", res.isSignIn + 0); // 签名
          this.loading.hide();
          // history.go(-2)
          // this.issubscirbe(); //判断是否关注
          // if (!res.isSubscribed) {
          //   this.showNoOpenIdTip();
          // }
        })
        .catch((e) => {
          console.log(e);
          this.loading.hide();
          this.errorStatus = e.response.status
          // this.errorText = e.response.statusText
          // this.$toast.text(e);
          // this.showNoOpenIdTip();
        });
    },
    noHref() {
      this.$toast.text("敬请期待");
    },
    examHandle() {
      // this.$toast.text("2024年活动即将开始，敬请期待！")
      const loading = this.$toast.loading('加载中...',{ 
        coverColor: "rgba(0,0,0,0.5)",
      })
      // if (
      //   this.signParams.openId === "" ||
      //   this.signParams.openId === undefined ||
      //   this.signParams.openId === null
      // ) {
      //   this.signParams.openId = window.sessionStorage.getItem("openId");
      // }
      
      if (this.errorStatus === 503) {
        this.$toast.text('系统正在维护中，请稍后重试');
        loading.hide()
      } else if (this.errorStatus === 501) {
        loading.hide()
        this.$dialog({
          title: "提示",
          lockBgScroll: true,
          noCancelBtn: true,
          okBtnTxt: '我知道了',
          content: `${this.errorText} 是我们系统维护时段，暂时无法参与活动，请谅解`,
          onOkBtn() {  //确定按钮点击事件
            this.close(); //关闭对话框
          }
        })
      } else if (this.errorStatus === 500) {
        this.$toast.text('系统繁忙，请稍后重试');
        loading.hide()
      } else if (sessionStorage.getItem('token') === null) {
        this.$toast.text("系统维护，请退出后在公众号中再试");
        loading.hide()
      } else if (sessionStorage.getItem('isSubscribed') !== "1") {
        loading.hide()
        this.showNoOpenIdTip();
      } else if (sessionStorage.getItem('isSignIn') !== "1") {
        loading.hide()
        // this.$toast.text("您还没有签名，需要签名后才能答题！");
        this.showSeleceAddressDialog = true;
        // this.$toast.text("请先签名！");
        // this.$router.push({
        //   path: "/",
        // });
      } else {
        loading.hide()
        this.$router.push({
          path: "/exam",
        });
      }
      // userApi
      //   .issubscribe({
      //     openId: this.signParams.openId,
      //   })
      //   .then((res) => {
      //     if (res.devMessage === "false") {
      //       this.showNoOpenIdTip();
      //     } else {
      //       if (this.isSignIn) {
      //         this.$toast.text("您已经签过名了！");
      //         this.$router.push({
      //           path: "/success",
      //           query: {
      //             signNumber: this.signNumber,
      //           },
      //         });
      //         return;
      //       } else {
      //         if (
      //           this.signParams.openId === "" ||
      //           this.signParams.openId === undefined ||
      //           this.signParams.openId === null
      //         ) {
      //           this.signParams.openId =
      //             window.sessionStorage.getItem("openId");
      //         }
      //         //判断key是否合法 key是否绑定别的openid
      //         userApi
      //           .validateKey({
      //             //key: this.signParams.key,
      //             openId: this.signParams.openId,
      //           })
      //           .then((res) => {
      //             console.log("sign=>", res);
      //             if (res.devMessage === "false") {
      //               this.showNoOpenIdTip();
      //             } else if (res.devMessage === "ok") {
      //               this.$toast.text("您还没有签名，需要签名后才能答题！");
      //               this.showSeleceAddressDialog = true;
      //             } else {
      //               this.$router.push({
      //                 path: "/exam",
      //               });
      //             }
      //           })
      //           .catch((e) => {
      //             console.log(e);
      //           });
      //       }
      //     }
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //   })
      //   .finally(() => {
      //     loading.hide()
      //   });
    },
    changeAddress(province, city, county, towns) {
      console.log(province, city, county, towns);
      this.signParams.province = province.Label;
      this.signParams.provinceCode = province.Value;
      this.signParams.city = city.Label;
      this.signParams.cityCode = city.Value;
      this.signParams.county = county.Label;
      this.signParams.countyCode = county.Value;
      this.signParams.towns = towns.Label;
      this.signParams.townsCode = towns.Value;
      this.signSubmit();
      // this.closeAddressDialog();
      // 选择地址后，需要填入姓名
      // this.showNameEnter();
    },
    closeAddressDialog() {
      this.showSeleceAddressDialog = false;
    },
    showNameEnter() {
      this.showNameDialog = true;
    },
    closeNameEnter() {
      this.showNameDialog = false;
    },
    changeName(text) {
      console.log("changeName", text);
      this.showNameDialog = false;
      this.signParams.name = text;
      this.signSubmit();
    },
    signSubmit() {
      if (sessionStorage.getItem('isSubscribed') !== "1") {
        //判断key是否合法 key是否绑定别的openid
        // userApi
        //   .validateKey({
        //     //key: this.signParams.key,
        //     openId: this.signParams.openId,
        //   })
        //   .then((res) => {
        //     console.log("sign=>", res);
        //     if (res.devMessage === "false") {
        //       this.showNoOpenIdTip();
        //     }
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //   });
        this.closeAddressDialog()
        this.showNoOpenIdTip();
        return;
      } else if (sessionStorage.getItem('isSignIn') === "1") {
        this.$toast.text("您已成功获得“反邪卫士”荣誉勋章");
        // this.$router.push({
        //   path: "/success",
        //   query: {
        //     signNumber: this.signNumber,
        //   },
        // });
        this.closeAddressDialog()
        return;
      }
      //  else {
      //   //判断key是否合法 key是否绑定别的openid
      //   userApi
      //     .validateKey({
      //       //key: this.signParams.key,
      //       openId: this.signParams.openId,
      //     })
      //     .then((res) => {
      //       console.log("sign=>", res);
      //       if (res.devMessage === "false") {
      //         this.showNoOpenIdTip();
      //       }
      //     })
      //     .catch((e) => {
      //       console.log(e);
      //     });
      // }
      // const openId = this.signParams.openId;
      // if (
      //   openId === "null" ||
      //   openId === null ||
      //   openId === undefined ||
      //   openId === ""
      // ) {
      //   // 显示没有获取到openId的提示
      //   this.showNoOpenIdTip();
      //   return;
      // }
      this.loading = this.$toast.loading("正在签名...", {
        coverColor: "rgba(0,0,0,0.5)",
      });
      userApi
        .signIn({
          userName: this.signParams.name,
          regionCode: `${this.signParams.townsCode || this.signParams.countyCode || this.signParams.cityCode}`,
        })
        .then((res) => {
          console.log("sign=>", res);
          // if (res.devMessage === "FAIL") {
          //   this.$toast.text(res.result);
          //   this.loading.hide();
          // } else if (res.devMessage === "false") {
          //   // 显示没有获取到openId的提示
          //   this.showNoOpenIdTip();
          // } else {
            this.$toast.text("恭喜，签名成功了！");
            this.closeAddressDialog()
            this.loading.hide();
            window.sessionStorage.setItem("token", res.token);
            window.sessionStorage.setItem("isSignIn", 1);
            window.sessionStorage.setItem("currentYear", res.year);
            window.sessionStorage.setItem("signNumber", res.rank);
            this.$router.push({
              path: "/exam",
            });
            // this.$router.push({
            //   path: "/success",
            //   query: {
            //     signNumber: res.result,
            //   },
            // });
          // }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.text(e.response.data.detail);
          this.loading.hide();
        });
    },
    showRank() {
      // this.showRankDialog = true;
      // if (
      //   this.signParams.openId === "" ||
      //   this.signParams.openId === undefined ||
      //   this.signParams.openId === null
      // ) {
      //   this.signParams.openId = window.sessionStorage.getItem("openId");
      // }
      // userApi
      //   .issubscribe({
      //     openId: this.signParams.openId,
      //   })
      //   .then((res) => {
      //     if (res.devMessage === "false") {
      //       this.showNoOpenIdTip();
      //     } else {
      //       this.showRankDialog = true;
      //     }
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //   });
        
      if (this.errorStatus === 503) {
        this.$toast.text('系统正在维护中，请稍后重试');
      } else if (this.errorStatus === 501) {
        this.$dialog({
          title: "提示",
          lockBgScroll: true,
          noCancelBtn: true,
          okBtnTxt: '我知道了',
          content: `${this.errorText} 是我们系统维护时段，暂时无法参与活动，请谅解`,
          onOkBtn() {  //确定按钮点击事件
            this.close(); //关闭对话框
          }
        })
      } else if (this.errorStatus === 500) {
        this.$toast.text('系统繁忙，请稍后重试');
      } else if (sessionStorage.getItem('token') === null) {
        this.$toast.text("系统维护，请退出后在公众号中再试");
      } else if (sessionStorage.getItem('isSubscribed') !== "1") {
        this.showNoOpenIdTip();
      } else {
        this.showRankDialog = true;
      }
    },
    closeRank() {
      this.showRankDialog = false;
    },
    showNoOpenIdTip() {
      this.showNoOpenIdTipDialog = true;
    },
    closeNoOpenIdTip() {
      this.showNoOpenIdTipDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.top {

  .top-title {
    padding: 10px;
    color: #087579;
    letter-spacing: 2px;
  }

  .top-img {
    width: 100%;
    height: 120vw;
    background: url("./../assets/2024/answer-header-2.png") no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;

    .sign {
      user-select: none;
      // background: rgba(255, 255, 255, 0.4);
      // border-radius: 50%;
      margin: auto;
      // padding: 6vw;
      display: inline-block;
      margin-top: -68vw;
      position: absolute;
      bottom: 15vw;
      left: 50%;
      transform: translate3d(-50%, 0, 0);

      img {
        // background: #2cceb9;
        width: 55vw;
        height: 55vw;
        border-radius: 50%;
        margin: auto;
        text-align: center;
        font-size: 34px;
        // color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: -2px;
        // box-shadow: 0 11px 40px #1a8c82;
        // border: 1px solid #5befde;
        transition: opacity 0.3s;

        &:active {
          opacity: 0.7;
        }
      }
    }
  }
}

.bottom {
  margin-top: -17vw;
  position: relative;
  z-index: 1;

  & > div {
    border-radius: 8px;
    padding: 0 15px;
    box-sizing: border-box;
    display: inline-block;
    width: 100%;
    margin: 4px 0;

    a {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;
      font-weight: 600;
      user-select: none;
      text-decoration: none;
      width: 100%;
      padding: 6px 10px;
      color: #333;
      font-size: 16px;
      letter-spacing: 2px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // box-shadow: 0 3px 8px #1a8c82;
      float: left;
      border-radius: 8px;
      box-sizing: border-box;
      // border: 1px solid rgba(255, 255, 255, 0.5);
      box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.2);

      div {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
      }

      img {
        min-width: 20px;
        min-height: 20px;
        padding: 0 10px 0 0;
      }
    }
  }
}
</style>
